import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { AthletePackage, AthletePackageChange, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useChangeAthletePackage(
  athletePackageId: string,
): UseMutationResult<AxiosResponse<AthletePackage>, AxiosError<ErrorMessage>, AthletePackageChange> {
  const queryClient = useQueryClient();

  const changeAthletePackage = (payload: AthletePackageChange): Promise<AxiosResponse<AthletePackage>> => {
    return client.put(`athlete-packages/${athletePackageId}/change/`, payload);
  };

  return useMutation(changeAthletePackage, {
    onSuccess: response => {
      queryClient.invalidateQueries(['athletePackages']);
      queryClient.invalidateQueries({
        queryKey: ['athletes', response.data.athlete],
      });
      queryClient.invalidateQueries({
        queryKey: ['athleteStatuses', response.data.athlete],
      });
      queryClient.invalidateQueries(['athleteEvents']);
      queryClient.invalidateQueries(['invoices']);
      queryClient.invalidateQueries('documents');
    },
  });
}
